import { getCloudEnvironmentDiscoverer } from '../discovery/getCloudEnvironmentDiscoverer';
import { getCloudEnvironmentStorage } from '../storage/getCloudEnvironmentStorage';
import type { CloudEnvironmentResolver } from '../types/CloudEnvironmentResolver';
import { CloudEnvironmentResolverImpl } from './CloudEnvironmentResolverImpl';

let cloudEnvironmentResolver: Promise<CloudEnvironmentResolver>;

export async function getCloudEnvironmentResolver(): Promise<CloudEnvironmentResolver> {
    if (!cloudEnvironmentResolver) {
        cloudEnvironmentResolver = getCloudEnvironmentResolverImpl();
    }

    return cloudEnvironmentResolver;
}

async function getCloudEnvironmentResolverImpl(): Promise<CloudEnvironmentResolver> {
    const storage = await getCloudEnvironmentStorage();
    // Pass the lazy discoverer getter (not an instance) so the discovery chunk is only loaded
    // when a resolution actually misses the cache; see CloudEnvironmentResolverImpl.
    return new CloudEnvironmentResolverImpl(storage, getCloudEnvironmentDiscoverer);
}
